import { creator } from '@helpers/httpMethods'
import { publicIp } from 'public-ip'

declare const pintrk: any

const trackPageView = () => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    pintrk('page')
  }
}

const trackEvent = async (
  eventName: string,
  params?: { serverEvent?: string; email?: string; data?: unknown }
) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    const ip = await publicIp()

    const eventID = Date.now()

    pintrk('track', eventName, { event_id: eventID })

    await creator({
      url: '/api/pinterest/conversions',
      body: {
        eventName: params?.serverEvent || eventName,
        eventID,
        email: params?.email,
        url: window.location.href,
        ip: ip,
        data: params?.data
      }
    })
  } else {
    console.log('[pin] Track Event:', eventName)
  }
}

const trackPurchase = async ({
  email,
  currency,
  value
}: {
  email: string
  currency: string
  value: number
}) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    const ip = await publicIp()

    const eventID = Date.now()

    pintrk('track', 'checkout', { value, currency, event_id: eventID })

    await creator({
      url: '/api/pinterest/conversions',
      body: {
        eventName: 'checkout',
        eventID,
        email,
        url: window.location.href,
        ip: ip,
        data: {
          currency,
          value: value.toString()
        }
      }
    })
  }
}

const pin = { trackPageView, trackEvent, trackPurchase }

export default pin
